import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Home from './pages/Home';
import Login from './pages/Login';
import DashboardHome from './pages/DashboardHome';
import HealthSummary from './pages/HealthSummary';
import MedicalProvider from './pages/MedicalProvider';
import Pharmacy from './pages/Pharmacy';
import PersonalFiles from './pages/PersonalFiles';
import Profile from './pages/Profile';
import EmergencyDashboard from './pages/EmergencyDashboard';
import ArchivedSummary from './pages/ArchivedSummary';
import Admin from './pages/Admin';
import Contact from './pages/Contact';
import DashboardContact from './pages/DashboardContact';
import EmergencyAccess from './pages/EmergencyAccess';
import EmergencyDemo from './pages/EmergencyDemo';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/dashboard');
  const isHomePage = location.pathname === '/';
  const isEmergency = location.pathname.startsWith('/emergency');
  const isLegal = ['/about', '/privacy', '/terms'].includes(location.pathname);

  return (
    <div className="App">
      {!isHomePage && !isDashboard && !isEmergency && !isLegal && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/emergency" element={<EmergencyAccess />} />
          <Route path="/emergency/demo" element={<EmergencyDemo />} />
          <Route path="/emergency/demo-card" element={<EmergencyDemo bypassAuth />} />
          <Route path="/emergency/:token" element={<EmergencyAccess />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="health-summary" element={<HealthSummary />} />
            <Route path="archived-summary" element={<ArchivedSummary />} />
            <Route path="medical" element={<MedicalProvider />} />
            <Route path="pharmacy" element={<Pharmacy />} />
            <Route path="personal" element={<PersonalFiles />} />
            <Route path="emergency-code" element={<EmergencyDashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="contact" element={<DashboardContact />} />
            <Route path="admin" element={
              <ProtectedRoute adminOnly>
                <Admin />
              </ProtectedRoute>
            } />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
